(function(){
  function init(){
    const root=document.querySelector('.product-box.bm-accessory-product');
    if(!root)return;
    root.querySelectorAll('[data-bm-accessory-popup],[data-bm-accessory-snap]').forEach(function(link){
      link.addEventListener('click',function(event){
        if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();
        const snap=link.hasAttribute('data-bm-accessory-snap');
        const popupWidth=snap?560:900;
        const popupHeight=snap?950:900;
        const mobile=window.matchMedia('(max-width:767px)').matches;
        const availableWidth=window.screen.availWidth||window.innerWidth;
        const availableHeight=window.screen.availHeight||window.innerHeight;
        const availableLeft=window.screen.availLeft||0;
        const availableTop=window.screen.availTop||0;
        const width=Math.min(popupWidth,mobile?window.innerWidth:Math.max(1,availableWidth-32));
        const height=Math.min(popupHeight,mobile?window.innerHeight:Math.max(1,availableHeight-48));
        const left=Math.round(Math.min(availableLeft+availableWidth-width,Math.max(availableLeft,window.screenX+(window.outerWidth-width)/2)));
        const top=Math.round(Math.min(availableTop+availableHeight-height,Math.max(availableTop,window.screenY+(window.outerHeight-height)/2)));
        const popup=window.open(link.href,snap?'bmAccessorySnap':'bmAccessorySupport','popup=yes,width='+width+',height='+height+',left='+left+',top='+top+',scrollbars=yes,resizable=yes');
        if(popup){popup.opener=null;popup.focus();}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
